// extracted by mini-css-extract-plugin
module.exports = {"comp":"BarPromoA_comp__ObKew"};